import { ReactNode } from "react";
import { Container } from "./styles";
interface ListCardBoxProps {
  children: ReactNode;
  className?: string;
  height?: string;
  rest?: string[];
}

export const ListCardBox = ({
  children,
  className,
  height,
  ...rest
}: ListCardBoxProps) => {
  return (
    <Container className={className} height={height} {...rest}>
      {children}
    </Container>
  );
};
